import { useRouter } from 'next/router'
import { useState } from 'react'
import SvgMail from '#/assets/images/card/mail_outline.svg'
import Button from '#/components/Button'
import LeadForm from '#/components/LeadForm'
import Modal from '#/components/Modal'
import RequestInfo from '#/components/RequestInfo'
import { MAP_PAGE } from '#/consts/url'
import UserBlock from '#/containers/PDF/components/UserBlock'
import cn from '#/utils/classnames'
import ReportsPurchase from '../ReportsPurchase'

type BottomBarProps = {
  className?: string
  isGuest: boolean
  agentInfo: TopHap.UserState['agentInfo']
  property: TopHap.Property
}

const BottomBar: React.FC<BottomBarProps> = ({ className, isGuest, agentInfo, property }) => {
  const [requestModal, showRequestModal] = useState(false)
  const [leadForm, showLeadForm] = useState(false)
  const router = useRouter()

  const closeRequestModal = () => {
    showRequestModal(false)
  }

  const closeLeadForm = () => {
    showLeadForm(false)
  }

  const showForm = () => {
    if (!isGuest && typeof agentInfo === 'undefined') {
      showLeadForm(true)
    } else {
      showRequestModal(true)
    }
  }

  return (
    <div className={cn('bg-white border-t border-b border-border flex space-x-2 items-center justify-center p-2 z-30', className)}>
      <Button
        className='h-10 rounded-lg bg-secondary px-4 text-sm text-white'
        onClick={showForm}
      >
        <SvgMail className='mr-1 h-[18px] w-[18px]' />
        Request Info
      </Button>
      <ReportsPurchase property={property} reportType='PROPERTY_FULL' />

      <Modal className='w-full' visible={requestModal} onClose={closeRequestModal}>
        <h2>{agentInfo?.displayName ? `Contact ${agentInfo.displayName}` : 'Contact an Agent'}</h2>
        {agentInfo && <UserBlock className='w-full rounded-xl border p-3' user={agentInfo} />}
        <span className='mb-1 mt-3 border-b border-border pb-2 text-sm' itemProp='telephone'>
          Fill in the contact form below
        </span>
        <RequestInfo property={property} small onClose={closeRequestModal} />
      </Modal>

      <Modal className='w-full' visible={leadForm} onClose={closeLeadForm}>
        <LeadForm leadOrigin={router.pathname === MAP_PAGE ? 'map-detail' : 'detail'} property={property} onClose={closeLeadForm} />
      </Modal>
    </div>
  )
}

export default BottomBar
